<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel w-85pc active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2 *ngIf="!isFromExternal">{{ 'label_Step' | translate}} 3 - {{ "grade_wizard_text3" | translate }}</h2>
                <h2 *ngIf="isFromExternal">{{ "grade_wizard_text3" | translate }}</h2>
                <app-video-icon [VideoUrl]="videoLink | safeUrl"></app-video-icon>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnShowConfigureshowLoggingAlertPanel();">
                    {{ 'log' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ "close" | translate }}
                </button>
            </div>
        </header>
        <div class="block mt-2 heightCalc-5">
            <div class="heightCalc-14">
                <app-grid [columns]="gridColumnDefs" [data]="gridCostCentreList" [gridConfigItems]="gridConfigItems"
                    [gridFilterItems]="gridFilterItems" (filterChanged)="fnGridFilterChanged($event)"
                    (onCellClick)="fnOnGridCellClick($event)" (onCheckAll)="fnOnGridCheckAll($event)">
                </app-grid>
            </div>
        </div>
    </div>
</div>

<app-assign-grade-panel *ngIf="showAssignCCPanel" [panelHeading]="panelHeading" 
    [(selectedItems)]="selectedClaimantList" (closePanel)="closeAssignPanel($event)"
    (uncheckEvent)="uncheckEvent($event)">
</app-assign-grade-panel>

<add-grade-panel *ngIf="showAddGradePanel" [inputModel]="addGradePanelInputModel"
  (submitEvent)="fnSubmitAddGradePanel($event)" (closePanelEvent)="fnCloseAddGradePanel($event)">
</add-grade-panel>

